import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { SuspenseLoader } from 'components/organisms';

const SessionsList = React.lazy(() => import('./components/sessions-list'));
const SessionSummary = React.lazy(() => import('./components/session-summary'));
const CreateSession = React.lazy(() => import('./components/sessions-create'));
const SessionMessageHub = React.lazy(() => import('./components/message-hub'));
const DigitalCoachingTool = React.lazy(() => import('./components/digital-coaching-tool'));

const SessionsBase = () => (
  <React.Suspense fallback={<SuspenseLoader />}>
    <Routes>
      <Route path="/" element={<SessionsList />} />
      <Route path="/create/:id" element={<CreateSession />} />
      <Route path="/create/" element={<CreateSession />} />
      <Route path="/summary/:id" element={<SessionSummary />} />
      <Route path="/messages/:id" element={<SessionMessageHub />} />
      <Route path="/messages/" element={<SessionMessageHub />} />
      <Route path="/feedback" element={<DigitalCoachingTool />} />
      <Route path="/feedback/:conversationId" element={<DigitalCoachingTool />} />
    </Routes>
  </React.Suspense>
);

export default SessionsBase;
